/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "jiya",
        "0": "yau",
        "1": "gobe",
        "future": {
          "one": "a cikin rana {0}",
          "other": "a cikin kwanaki {0}"
        },
        "past": {
          "one": "rana da ya gabata {0}",
          "other": "kwanaki da suka gabata {0}"
        }
      },
      "day-narrow": {
        "-1": "jiya",
        "0": "yau",
        "1": "gobe",
        "future": {
          "one": "a cikin rana {0}",
          "other": "a cikin kwanaki {0}"
        },
        "past": {
          "one": "rana da ya gabata {0}",
          "other": "kwanaki da suka gabata {0}"
        }
      },
      "day-short": {
        "-1": "jiya",
        "0": "yau",
        "1": "gobe",
        "future": {
          "one": "a cikin rana {0}",
          "other": "a cikin kwanaki {0}"
        },
        "past": {
          "one": "rana da ya gabata {0}",
          "other": "kwanaki da suka gabata {0}"
        }
      },
      "hour": {
        "0": "wannan awa",
        "future": {
          "one": "cikin {0} awa",
          "other": "cikin {0} awa"
        },
        "past": {
          "one": "{0} awa da ya gabata",
          "other": "{0} awa da ya gabata"
        }
      },
      "hour-narrow": {
        "0": "wannan awa",
        "future": {
          "one": "cikin {0} awa",
          "other": "cikin {0} awa"
        },
        "past": {
          "one": "{0} awa da ya gabata",
          "other": "{0} awa da ya gabata"
        }
      },
      "hour-short": {
        "0": "wannan awa",
        "future": {
          "one": "cikin {0} awa",
          "other": "cikin {0} awa"
        },
        "past": {
          "one": "{0} awa da ya gabata",
          "other": "{0} awa da ya gabata"
        }
      },
      "minute": {
        "0": "wannan mintin",
        "future": {
          "one": "cikin {0} minti",
          "other": "cikin {0} minti"
        },
        "past": {
          "one": "{0} minti da ya gabata",
          "other": "{0} minti da ya gabata"
        }
      },
      "minute-narrow": {
        "0": "wannan mintin",
        "future": {
          "one": "cikin {0} minti",
          "other": "cikin {0} minti"
        },
        "past": {
          "one": "{0} minti da ya gabata",
          "other": "{0} minti da ya gabata"
        }
      },
      "minute-short": {
        "0": "wannan mintin",
        "future": {
          "one": "cikin {0} minti",
          "other": "cikin {0} minti"
        },
        "past": {
          "one": "{0} minti da ya gabata",
          "other": "{0} minti da ya gabata"
        }
      },
      "month": {
        "-1": "watan da ya gabata",
        "0": "wannan watan",
        "1": "wata na gaba",
        "future": {
          "one": "a cikin watan {0}",
          "other": "a cikin watanni {0}"
        },
        "past": {
          "one": "watan da ya gabata",
          "other": "watanni da suka gabata {0}}"
        }
      },
      "month-narrow": {
        "-1": "watan da ya gabata",
        "0": "wannan watan",
        "1": "wata na gaba",
        "future": {
          "one": "a cikin watan {0}",
          "other": "a cikin watan {0}"
        },
        "past": {
          "one": "watan da ya gabata {0}",
          "other": "watan da ya gabata {0}"
        }
      },
      "month-short": {
        "-1": "watan da ya gabata",
        "0": "wannan watan",
        "1": "wata na gaba",
        "future": {
          "one": "a cikin watan {0}",
          "other": "a cikin watan {0}"
        },
        "past": {
          "one": "watan da ya gabata",
          "other": "watan da ya gabata {0}"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "kwatan karshe",
        "0": "wannan kwatan",
        "1": "kwata na gaba",
        "future": {
          "one": "a cikin kwata {0}",
          "other": "a cikin kwatas {0}"
        },
        "past": {
          "one": "kwata da suka gabata {0}",
          "other": "kwatas da suka gabata {0}"
        }
      },
      "quarter-narrow": {
        "-1": "kwatan karshe",
        "0": "wannan kwatan",
        "1": "kwata na gaba",
        "future": {
          "one": "a cikin kwata {0}",
          "other": "a cikin kwatas {0}"
        },
        "past": {
          "one": "kwata da suka gabata {0}",
          "other": "kwatas da suka gabata {0}"
        }
      },
      "quarter-short": {
        "-1": "kwatan karshe",
        "0": "wannan kwatan",
        "1": "kwata na gaba",
        "future": {
          "one": "a cikin kwata {0}",
          "other": "a cikin kwatas {0}"
        },
        "past": {
          "one": "kwata da suka gabata {0}",
          "other": "kwatas da suka gabata {0}"
        }
      },
      "second": {
        "0": "yanzu",
        "future": {
          "one": "cikin {0} dakika",
          "other": "cikin {0} dakika"
        },
        "past": {
          "one": "{0} dakika da ya gabata",
          "other": "{0} dakika da ya gabata"
        }
      },
      "second-narrow": {
        "0": "yanzu",
        "future": {
          "one": "cikin {0} dakika",
          "other": "cikin {0} dakika"
        },
        "past": {
          "one": "{0} dakika da ya gabata",
          "other": "{0} dakika da ya gabata"
        }
      },
      "second-short": {
        "0": "yanzu",
        "future": {
          "one": "cikin {0} dakika",
          "other": "cikin {0} dakika"
        },
        "past": {
          "one": "{0} dakika da ya gabata",
          "other": "{0} dakika da ya gabata"
        }
      },
      "week": {
        "-1": "satin da ya gabata",
        "0": "wannan satin",
        "1": "sati na gaba",
        "future": {
          "one": "a cikin mako {0}",
          "other": "a cikin makonni {0}"
        },
        "past": {
          "one": "mako da ya gabata {0}",
          "other": "makonni da suka gabata {0}"
        }
      },
      "week-narrow": {
        "-1": "satin da ya gabata",
        "0": "wannan satin",
        "1": "sati na gaba",
        "future": {
          "one": "a cikin mako {0}",
          "other": "a cikin mako {0}"
        },
        "past": {
          "one": "mako da suka gabata {0}",
          "other": "mako da ya gabata {0}"
        }
      },
      "week-short": {
        "-1": "satin da ya gabata",
        "0": "wannan satin",
        "1": "sati na gaba",
        "future": {
          "one": "a cikin mako {0}",
          "other": "a cikin mako {0}"
        },
        "past": {
          "one": "mako da ya gabata {0}",
          "other": "mako da ya gabata {0}"
        }
      },
      "year": {
        "-1": "bara",
        "0": "bana",
        "1": "badi",
        "future": {
          "one": "a shekarar {0}",
          "other": "a shekaru {0}"
        },
        "past": {
          "one": "shekara da suka gabata {0}",
          "other": "shekara da suka gabata {0}"
        }
      },
      "year-narrow": {
        "-1": "bara",
        "0": "bana",
        "1": "badi",
        "future": {
          "one": "a shekarar {0}",
          "other": "a shekaru {0}"
        },
        "past": {
          "one": "shekara da suka gabata {0}",
          "other": "shekara da suka gabata {0}"
        }
      },
      "year-short": {
        "-1": "bara",
        "0": "bana",
        "1": "badi",
        "future": {
          "one": "a shekarar {0}",
          "other": "a shekaru {0}"
        },
        "past": {
          "one": "shekara da suka gabata {0}",
          "other": "shekara da suka gabata {0}"
        }
      }
    },
    "locale": "ha-NE"
  });
}